// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"f9405be9","88":"07561b24","115":"9040a60d","144":"4619876d","163":"c4a16e6e","311":"17baf0eb","363":"3e8f86da","453":"63e577b6","536":"1827a25f","558":"c9d99042","748":"74a43219","834":"22bee7a6","883":"dd5fa5e3","912":"510dc639","917":"93dbfda6","966":"1f452bed"}[chunkId] + ".chunk.js";
};